import React from "react";
import { FormGroup } from "react-bootstrap";
import { Field } from "react-final-form";
import { Error } from "../Conditionals/Error";

export const TextareaField = ( props ) => {
    const { fieldId, fieldLabel, fieldRequired, clearField, hint, placeholder, validator } = props
    const textareaId = fieldId.split( " " ).join( "" )
    return <Field name={ fieldId + " " + fieldLabel } validate={ validator }>
        { ( { input, meta } ) => (
            <FormGroup
                className={ ((meta.error || input.value === "") ? "has-error " : " ") + (!meta.error && (meta.modified || meta.touched) ? "is-success " : " ") }>
                <div className="textarea">
                    <label htmlFor={ fieldId }>{ fieldLabel }
                        { (meta.error || input.value === "") &&
                        <Error name={ fieldId + " " + fieldLabel }>{ meta.error }</Error> }
                    </label>
                    { hint && <p>
                        { hint }
                    </p> }
                    <textarea
                        { ...input }
                        id={ textareaId }
                        placeholder={ placeholder || "" }
                        className={ "form-control" }
                        required={ fieldRequired }
                    >
                        { clearField ? "" : input.value }
                    </textarea>
                </div>
            </FormGroup>
        ) }
    </Field>;
}